import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { EmptyState, ToastContainer } from 'mailup-web-components'

import BounceTable from './BounceTable'
import Header from './Header'

import Page from 'Containers/Page'

import { resultsStateEmptyState } from './recoil/state/result'

import {
  getRecipientCallback,
  resetPageCallback,
} from './recoil/callbacks/callbacks'

const ProfileBounce = () => {
  const intl = useIntl()
  const { idRecipient } = useParams()

  const isEmptyState = useRecoilValue(resultsStateEmptyState)
  const getRecipient = useRecoilCallback(getRecipientCallback, [])

  const resetPage = useRecoilCallback(resetPageCallback, [])

  const init = () => {
    getRecipient(idRecipient)
    //  loadBounceTable({ idRecipient })
  }

  useEffect(() => {
    init()

    return () => {
      resetPage()
    }
  }, [])

  return (
    <>
      <Header />
      <ToastContainer />
      <Page onReload={init}>
        {isEmptyState ? (
          <EmptyState
            title={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientBouncesTitle',
            })}
            description={intl.formatMessage({
              id: 'Load.EmailMessageList.EmptyStateActiveRecipientBouncesDescription',
            })}
          />
        ) : (
          <BounceTable />
        )}
      </Page>
    </>
  )
}

export default ProfileBounce
